module.exports = __webpack_public_path__ + "img/PlaySplitCardDrawPoker_EGM.893f9649.png";